export function getAvailableSlots(signupItem) {
  const { totalSlots, slotsTaken } = signupItem;
  const availableSlots = totalSlots - slotsTaken;

  if (availableSlots < 0) return 0;
  return availableSlots;
}
